<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>leaderboard</mat-icon>
				<span>Statistik</span>
			</div>

			<mat-spinner
				diameter=30
				[ngStyle]="{ opacity: bInProgress ? '1' : '0' }"
			>
			</mat-spinner>

		</div>

		<div style="padding:1em; margin: 0em auto 0 auto; max-width: 50em; position: relative">

			<h3
				*ngIf="!members.length && !bInProgress" 
				style="text-align: center;"
			>
				Keine Mitglieder vorhanden
			</h3>

			@if( members.length ) {

				<div class="flexCol">
	
					<!-- <chips-autocomplete style="width: 100%"
						label="Unternehmen"
						[allElems]="chipsAutocompleteElements"
						(newValue)="newCompanySelection($event)"></chips-autocomplete> -->
	
					@if( selectedMembers.length ) {

						<div class="selectedMembers">
		
							<div
								*ngFor="let m of selectedMembers; let i=index"
								class="divMemberSelected"
							>
								<span
									class="customBtn"
									(click)="showInfoMember(i)"
								>
									<span style="vertical-align: middle; display: inline; margin-right: 1em">
										{{m.mitgliedsname}}
									</span>
									<span
										class="material-icons btnShowInfo"
										style="vertical-align: middle;"
										>info_outline</span>
								</span>
								<!-- style="position: absolute; right: -5px; top: -10px" -->
								<button
									mat-icon-button
									color="primary"
									class="removeBtn"
									(click)="removeMember(m.mitgliedId)"
								>
									<mat-icon>clear</mat-icon>
								</button>
							</div>
		
						</div>

					}
	
					<misc-combobox
						*ngIf="bShowAutoComplete"
						style="width: 100%;"
						placeholder="Mitglieder auswählen"
						[elements]="memberListCombobox" 
						(onSelected)="selectMember($event)"
					/>
	
					<button
						*ngIf="bShowBtnCompare"
						id="compareBtn"
						mat-raised-button
						color="basic"
						(click)="showCompareInput()"
					>
						Vergleichen
					</button>
	
					<!-- <div *ngFor="let n of membersToChoose; let i = index" >
						<misc-combobox
							style="width: 100%;"
							[elements]="memberListCombobox" 
							(onSelected)="onMemberSelected($event,i)">
						</misc-combobox>
						<button mat-icon-button color="primary" 
							style="position: absolute; right: 0"
							*ngIf="membersToChoose.length > 1"
							(click)="removeMember(i)">
							<mat-icon>clear</mat-icon>
						</button>
					</div> -->
	
					@if( selectedMembers.length ) {

						<div class="rowScreenColPhone" style="margin: 0;">
	
							<mat-form-field appearance="outline">
								<mat-label>Sparte</mat-label>
								<mat-select
									[formControl]="selectedSectionsCtrl"
									multiple
								>
									<mat-option *ngIf="sectionsAssigned.length > 1" value="">
										Alle
									</mat-option>
									<mat-option
										*ngFor="let s of sectionsAssigned"
										[value]="s.sparteId"
										[disabled]="selectedSectionIds.includes('')"
									>
										{{s.sparteBezeichnung}}
									</mat-option>
								</mat-select>
							</mat-form-field>
	
							@if( selectedMembers.length > 1 ) {

								<span style="width: 4em;"></span>
								<mat-form-field appearance="outline">
									<mat-label>Berichtsjahr</mat-label>
									<mat-select [(value)]="yearSelected" (selectionChange)="prepareData()">
										<mat-option *ngFor="let y of years" [value]="y">
											{{y}}
										</mat-option>
									</mat-select>
								</mat-form-field>

							}
							
						</div>

					}
		
				</div>

			}

		</div>

	</div>

	<!-- <div *ngIf="selectedMembers.length == 1" style="margin: 3em 0em; text-align: center;">
		<h2>
			<span class="customBtn" (click)="showInfoMember(0)">
				{{selectedMembers[0].mitgliedsname}} 
				<span class="material-icons" style="vertical-align: bottom;">info_outline</span>
			</span>
		</h2>
	</div> -->

	<ng-container *ngIf="!bInProgress">
		<div *ngFor="let ds of dataSources; let i = index" style="margin:2em 0">

			<ng-container *ngIf="!ds.data.length">
				<div class="fakeHeaderCell">
					<span class="customBtnWhite" (click)="showInfoSection(i)">
						{{sectionDesignation(i)}}
						<span class="material-icons spanBtnBottom btnShowInfo">info_outline</span> 
					</span>
				</div>
				<div class="fakeCell">
					Keine Data für Sparte/Jahr verfügbar
				</div>
			</ng-container>

			<mat-table
				*ngIf="ds.data.length"
				multiTemplateDataRows
				[dataSource]="ds"
				class="mat-elevation-z8"
			>
	
				<ng-container matColumnDef="twigXS">
					<mat-header-cell
						*matHeaderCellDef
						class="showOnSmallScreen"
						style="justify-content: flex-start;"
					>
						<span class="customBtnWhite" (click)="showInfoSection(i)">
							{{sectionDesignation(i)}}
							<span class="material-icons spanBtnBottom btnShowInfo">info_outline</span> 
						</span>
					</mat-header-cell>
					<mat-cell
						*matCellDef="let o"
						class="showOnSmallScreen cellXS"
					>
						{{o.twigXS}}
						<label [label]="o.twigXL" [info]="o.info"></label>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="twigXL">
					<mat-header-cell
						*matHeaderCellDef
						class="hideOnSmallScreen firstCol" 
					>
						<span class="customBtnWhite" (click)="showInfoSection(i)">
							{{sectionDesignation(i)}}
							<span class="material-icons spanBtnBottom btnShowInfo">info_outline</span> 
						</span>
					</mat-header-cell>
					<mat-cell
						*matCellDef="let o"
						class="hideOnSmallScreen firstCol" 
					>
						<label [label]="o.twigXL" [info]="o.info"></label>
					</mat-cell>
				</ng-container>

				<ng-container [matColumnDef]="c" *ngFor="let c of columnsStats; let j = index;">
					<mat-header-cell *matHeaderCellDef>
						<div style="text-align: center;">
							<mat-icon *ngIf="j==(indexColLeft) && (j!=0)"
								matRipple
								[matRippleCentered]=true
								[matRippleUnbounded]=true
								[matRippleRadius]=30
								class="customBtnWhite" 
								(mousedown)="preventDefault($event)"
								(click)="slideColumnsLeft()">arrow_left</mat-icon>
							<span *ngIf="selectedMembers.length == 1">
								{{colDesignation(c)}}
							</span>
							<span
								*ngIf="selectedMembers.length > 1"
								class="customBtnWhite" 
								(click)="showInfoMember(j)"
							>
								{{colDesignation(c)}} 
								<span
									class="material-icons btnShowInfo" 
									style="vertical-align: bottom;"
								>info_outline</span>
							</span>
							<mat-icon *ngIf="j==(indexColLeft + columnsStatsDisplayed.length-2) && (j!==columnsStats.length-1)"
								matRipple
								[matRippleCentered]=true
								[matRippleUnbounded]=true
								[matRippleRadius]=30
								class="customBtnWhite" 
								(mousedown)="preventDefault($event)" 
								(click)="slideColumnsRight()">arrow_right</mat-icon>
						</div>
					</mat-header-cell>
					<mat-cell *matCellDef="let o">
						{{formatStatsValue(o, o[c])}}
						<!-- <span *ngIf="!o[c] && (o[c]!==0)" style="font-size: x-small;">N/A</span> -->
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="['twigXS']" class="showOnSmallScreen"></mat-header-row>
				<mat-header-row *matHeaderRowDef="columnsStatsDisplayed"></mat-header-row>
				<mat-row
					*matRowDef="let row; columns: ['twigXS'];" 
					class="showOnSmallScreen rowXS"
				>
				</mat-row>
				<mat-row *matRowDef="let row; columns: columnsStatsDisplayed;"></mat-row>
			
			</mat-table>
			<!-- {{ds.data | json}} -->
		</div>

		<div *ngIf="dataSources.length" style="text-align: center">
			<button
				mat-raised-button
				(click)="print()"
			>
				<span class="material-icons">print</span>
				Drucken
			</button>
		</div>

	</ng-container>

</div>
